export class StaticLookupListModel {
    id = null;
    name;
    description = '';
}
//# sourceMappingURL=static-lookup-list.js.map